import { useState, useEffect } from 'react';
import '../Spinner/Spinner.css';
import logo from '../../Assets/Images/logo.png';
import gear from '../../Assets/Images/gear.png';

const Spinner = () => {
    const [showLogo, setShowLogo] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLogo(true);
        }, 2500); // Show the logo after 4 seconds

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className='h-screen flex flex-col items-center justify-center'>
            {showLogo && (
                <div className="logo-container w-24 h-24 mb-2 animate-fadeIn">
                    <img className='h-full w-full object-contain' src={logo} alt="Logo" />
                </div>
            )}
            <div className="loader-container mt-2">
                <div className="gear" id="gear1">
                    <img src={gear} alt="an illustration of a gear" />
                </div>
                <div className="gear" id="gear2">
                    <img src={gear} alt="an illustration of a gear" />
                </div>
            </div>
        </div>     
    );
};

export default Spinner;
